<template>
<div class="chapter">
<div class="inner_page">
      ﻿



<title>The Border Lord</title>
<link href="pdlmsr.css" rel="stylesheet" type="text/css"/>
<meta content="text/html; charset=UTF-8"/>
<div class="frontMatterPage" id="fm01"><a id="page01"><div class="chapterHead"><h2 class="chapterTitle1"><span class="bold"><span>Lachlan cursed this ridiculous farce.</span></span></h2></div><div class="chapterBody"><p class="chapterOpenerText"><span>More than twenty years of selfless service to the king, repaid by the fetter of marriage to a woman who was scared of her own shadow. If it wasn’t so permanent he might have laughed. Indeed, he had seen the puzzled faces of his men as they tried to fathom out the character of his new wife and failed.</span></p><p class="lineSpace1"><span> </span></p><p class="paraNoIndent"><span>She had hit him!</span></p><p class="lineSpace1"><span> </span></p><p class="paraNoIndent"><span>His frightened mouse of a wife had hit him. Hard. And in the shadowed depths of her amber eyes he had recognized what he so often saw in his own.</span></p><p class="lineSpace1"><span> </span></p><p class="paraNoIndent"><span>Secrets.</span></p><br/><p class="paraCenter1"><span><span class="bold"><span><em class="italic"><span>The Border Lord</span></em><br/>
Harlequin <sup>®</sup> Historical</span></span></span></p></div></a></div>
<a id="page01">
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// borderlordthe_fm01.vue?7ac5e84c